import VrtTransaction from './modules/VrtTransactionVuex'
import Bill from "./modules/BillVuex"
import Check from './modules/CheckVuex'
import Deposit from './modules/DepositVuex'
import Envelope from './modules/EnvelopeVuex'
import ReturnedCheck from './modules/ReturnedCheckVuex'
import Payment from './modules/PaymentVuex'
import ClientFinancial from './modules/ClientVuex'

export default {
  VrtTransaction,
  Bill,
  Check,
  ClientFinancial,
  Deposit,
  Envelope,
  ReturnedCheck,
  Payment,
}